<template>
  <div class="social-media-bar">
    <!-- Pixelate Effect -->
    <!-- BY: https://codepen.io/AmeliaBR/pen/QEmBko -->
    <svg x="0px" y="0px" width="0px" height="0px" viewBox="0 0 810 600">
      <defs>
        <filter id="pixelate" x="0" y="0">
          <feFlood height="2" width="2" />

          <feComposite width="1" height="10">
            <animate attributeName="height" from="100" to="1" dur="0.5s" fill="freeze" />
            <animate attributeName="width" from="100" to="1" dur="0.5s" fill="freeze" />
          </feComposite>
          <feTile result="a" />

          <feComposite in="SourceGraphic" in2="a" operator="in" />

          <feMorphology operator="dilate" radius="5">
            <animate
              attributeName="radius"
              calcMode="discrete"
              values="50;45;40;35;30;25;20;15;10;5;0"
              dur="0.5s"
              fill="freeze"
            />
          </feMorphology>
        </filter>
      </defs>
    </svg>

    <transition-group @beforeEnter="beforeEnter" @enter="enter" name="appear" class="social-media">
      <social-media-icon
        v-for="(social, i) in socialMedias"
        :key="social.name"
        :social="social"
        :data-index="i"
        class="icon"
      />
    </transition-group>
  </div>
</template>

<script>
/**
 * Shows all the available social medias
 */
import SocialMediaIcon from "./social-media-icon"
import { setTimeout } from "timers"
import socials from "@/constants/social-media.js"
export default {
  components: {
    SocialMediaIcon
  },
  data() {
    return {
      socialMedias: socials.ALL_SOCIALS,
    }
  },
  methods: {
    // initial anim
    beforeEnter(el) {
      el.style.opacity = 0
      // el.style.filter = "url(#pixelate)"
    },
    // stagged anim
    enter(el) {
      setTimeout(() => {
        el.style.opacity = 0.5
      }, 200)
    }
  }
}
</script>

<style scoped lang="scss">
.social-media-bar {
  z-index: 1000;
  position: absolute;
}

.social-media {
  position: fixed;
  top: 35%;
  left: 0;
  display: flex;
  flex-direction: column;
  padding: 5px;
  padding-left: 10px;
}
.icon:not(:first-child) {
  margin-top: 10px;
}
</style>

